import React, { useState, useEffect } from "react";
import HeaderBar from "../components/HeaderBar";
import Sidebar from "../components/Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileContract,
  faHourglassClock,
  faTally,
  faUsers,
} from "@fortawesome/pro-regular-svg-icons";
import { getContactPersonForAgreement } from "../api/Agreement";
import { useAuth } from "../providers/AuthContext";
import LoadingAgreements from "../components/LoadingAgreements";

function NotFoundPage() {
  const { getAccessToken, getUserRole, user } = useAuth(); // Extract user from useAuth
  const [agreements, setAgreements] = useState([]);
  const [loading, setLoading] = useState(true);
  const userRole = getUserRole();
  const [contactPerson, setContactPerson] = useState(null);

  return (
    <>
      <HeaderBar />
      <div className="flex">
        <Sidebar />
        <div className="page">
          <img
            src="/assets/images/imageBG2.png"
            className="-z-10 object-cover absolute opacity-25 w-full h-full"
            alt="Background"
          />
          <div className="page-content">
            <div className="px-[9.5rem]">
              <div className="flex flex-col items-center">
                <div className="p-4 max-w-[48.125rem]">
                  <h1 className="text-center text-3xl font-bold pb-4">
                    404
                  </h1>
                  <p className="text-center py-4">
                    We could not find the page you were looking for.
                  </p>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      
    </>
  );
}

export default NotFoundPage;
